// NOTE: this util doesn't work with vue-quill-editor, please use Vanilla Quill

import Quill from "quill"
import ImageUploader from "quill-image-uploader"
import { hasKey } from "@/utils/objectUtil"
import { requestSignature, uploadToS3 } from "@/apis/fileUpload"

Quill.register("modules/imageUploader", ImageUploader)

async function upLoadImageToS3(file) {
  const signature_resp = await requestSignature(
    file.name,
    file.type,
    "edyst-email-templates"
  )
  // We're now using DO edge URL, may go back to cloudfront CDN
  const { postEndpoint, publicEdgeUrl } = signature_resp.data
  const sig_obj = signature_resp.data.signature

  const awsResp = await uploadToS3(postEndpoint, sig_obj, file)
  if (awsResp.status === 201) {
    return publicEdgeUrl
  }
  throw new Error("Failed to upload image")
}

export const imageUploader = {
  upload: file =>
    new Promise(async (resolve, reject) => {
      try {
        const URL = await upLoadImageToS3(file)
        resolve(URL)
      } catch (err) {
        console.error(err)
        this.$noty.error("Failed to upload the image, please try again")
        reject(err)
        return ""
      }
      return ""
    }),
}

export default function setupImageUpload(quillEditorOptions) {
  if (!quillEditorOptions || typeof quillEditorOptions !== "object") {
    throw new Error(
      "quillEditorOptions: is required to setup quill editor image upload, please pass your quill editor options object"
    )
  }

  if (!hasKey(quillEditorOptions, "modules")) {
    quillEditorOptions.modules = { toolbar: [] }
  }

  if (!hasKey(quillEditorOptions.modules, "toolbar")) {
    quillEditorOptions.modules.toolbar = []
  }

  quillEditorOptions.modules.imageUploader = imageUploader
  quillEditorOptions.modules.toolbar.push(["image"])
}
